import React from 'react';
import { PieChart, Pie, Cell, Tooltip } from 'recharts';

const DonutChart = ({ data, onSelectLevel }) => {
  const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

  const handleClick = (data) => {
    onSelectLevel(data.name);
  };

  let newData = data.map((item) => {
    return {
      name: item.nombre,
      value: 1,
    };
  });

  return (
    <PieChart width={400} height={400}>
      <Pie
        data={newData}
        dataKey="value"
        nameKey="name"
        cx="50%"
        cy="50%"
        innerRadius={90}
        outerRadius={120}
        fill="#8884d8"
        onClick={(data, index) => handleClick(data)}
        label={({ name }) => name} // Change label to display names
      >
        {newData.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
        ))}
      </Pie>
      <Tooltip />
    </PieChart>
  );
};

export default DonutChart;
